module.exports = __webpack_public_path__ + "fonts/Gilroy-Black.6b91119.otf";